import React, { useState } from 'react';

import SimpleBar from 'simplebar-react';
import Modal from '../../utils/customModal';
import detailImage from "../../../../static/images/error-detail.svg";
import IconInformationIllustrative from 'canvas-core-react/lib/IconInformationIllustrative';
import { useTranslation } from 'react-i18next';

const ModalResults = ({ results, closeModal, mode }) => {
  const modalResults = {
    showModal: true,
    showDetail: false
  }

  const {t} = useTranslation();

  const [modal, setModal] = useState(modalResults);
  const success = mode == 'draft' ?
    `${results.totalLinesOk}/${results.totalLines} se enviaron a aprobar correctamente` :
    `${results.totalLinesOk}/${results.totalLines} aprobaciones exitosas`;
  const fail = mode == 'draft' ?
    `${results.totalLinesFail}/${results.totalLines} presentan errores` :
    `${results.totalLinesFail}/${results.totalLines} aprobaciones fallidas`;

  const showDetails = () => {
    setModal({ showModal: false, showDetail: true });
  }
  return <React.Fragment>
    <Modal
      handleClose={() => closeModal()}
      show={modal.showModal}
      id="Modal"
    >
      <div className="modal-detail modal-container">
        <IconInformationIllustrative className="absolute-element" />
        <div className="indicator-credit">
          <p className="p-title"><strong>Gestión de facturas</strong></p>
          <p><strong>El resultado de la operación es el siguiente:</strong></p>
          {results.totalLinesOk > 0 && (
            <p className="p-titleProvider">
              <strong>{success}</strong>
            </p>
          )}
          {results.totalLinesFail > 0 && (
            <div>
              <p className="p-titleProvider1">
                <strong>{fail}</strong>
              </p>
            </div>
          )}
          <div className="actions">
            <a onClick={() => showDetails()} className="continue-btn">{`${t("general.labels.fileModal.detail")}`}</a>
            <a onClick={() => closeModal()} className="continue-btn active">{t("general.buttons.close")}</a>
          </div>
        </div>
      </div>
    </Modal>
    <Modal
      handleClose={() => closeModal()}
      show={modal.showDetail}
      id="Modal"
    >
      <SimpleBar forceVisible="y" style={{ maxHeight: 400, width: 600 }}>
        <div className="modal-detail modal-container">
          <img src={detailImage} className="detail-image" />
          <p>Detalle de las facturas procesadas.</p>
          <table className="table table-striped">
            <thead>
              <tr>
                <th className="thLine"># Factura</th>
                <th scope="col">Mensaje</th>
              </tr>
            </thead>
            <tbody>
              {results.details.map((element, id) => {
                return (
                  <tr key={id}>
                    <td className="tdLine">{element.billNumber}</td>
                    <td className="company">{element.message}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
          <div className="actions">
            <a onClick={() => setModal({ showModal: true, showDetail: false })} className="continue-btn">{t("general.buttons.back")}</a>
          </div>
        </div>
      </SimpleBar>
    </Modal>
  </React.Fragment>
}

export default ModalResults;